import React from 'react'
import foto1 from '../asset/post1 h.jpg'
import foto2 from '../asset/post 2 h.jpg'

const Achivment = () => {
  return (
    
    <div id="achievment" className=" w-[full] text-center items-center justify-center bg-slate-100">
        <h2 className="text-center font-extrabold text-3xl font-convergence font-EBGaramond ">Activities & Achievment</h2>
        <span className=" inline-flex justify-center items-center  w-[14%] h-2"></span>
        <p className=' max-w-[1200px] m-auto text-2xl max-md:text-lg font-Montserrat'> We have done many things to support our success in this export business, and from this activity, we have gained a lot of experience and learned to develop even better. </p>
        <br />

        <div className="max-w-[1400px] m-auto   grid lg:grid-cols-2 gap-4  rounded-xl  ">
          {/* left Side */}
          <div
            className="grid mx-5 "
            data-aos="fade-down"
            data-aos-duration="2000"
          >
            <img src={foto1} alt="Export Import Activity" />
          </div>
          {/* right Side */}
          <div
            className="grid mx-8   "
            data-aos="fade-down"
            data-aos-duration="2000"
          >
            <img src={foto2} alt="Export Import Activity" />
          </div>
        </div>
      </div>
  )
}

export default Achivment